module.exports = __webpack_public_path__ + "grundformen.260a49b93ffef2c8064b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/icons/grundformen.png
// module id = ./src/css/icons/grundformen.png
// module chunks = styles